import { createPortal as r } from "react-dom";
const e = _ref => {
  let {
    children: t,
    to: o
  } = _ref;
  return o ? typeof o == "string" ? r(t, document.getElementById(o)) : r(t, o) : t;
};
export { e as Portal };